'use strict';

/* Header Controller */

angular.module('game').controller('headerCtrl', ['$scope', '$rootScope', 'audioService', 'i18nService', '$document', '$window', '$location', '$route', 'apiCall', 'globalService', 'gameSettings',
  function ($scope, $rootScope, audioService, i18nService, $document, $window, $location, $route, apiCall, globalService, gameSettings) {

    var iconVolumeOff = $scope.contentURL + "images/common/volume-mute.svg";
    var iconVolumeOn = $scope.contentURL + "images/common/volume-high.svg";

    var $timeout = globalService.angularServices.$timeout;

    $scope.config = gameSettings;
    $scope.iconVolume = iconVolumeOn;
    $scope.languages =  $scope.config.settings.languages;
    $scope.showMultilanguageSelector = $scope.languages.length > 1;
    $scope.selectedLanguageKey = "";
    $scope.userInitials = ""
    $scope.reports = [];

    function init() {
      globalService.userService.getUser().then(function (user) {
        $scope.userInitials = user.nameFront.substr(0, 2);
        if (!user.volume || /.*(challenge|asset|onboarding).*/.test($location.path())) {
          audioService.setVolume(0.0);
          audioService.stop();
          $scope.iconVolume = iconVolumeOff;
        } else if (user.volume && $location.path().indexOf("challenge") === -1){
          audioService.setVolume(gameSettings.globalAudio.default);
          audioService.play();
          $scope.iconVolume = iconVolumeOn;
        }
        if ($scope.showMultilanguageSelector) {
          console.log("Current user language: ", user.language);
          // Set selected the current user language
          $scope.selectedLanguageKey = user.language;
        }
        if (user.roles.indexOf("ROLE_ADMIN") !== -1) {
          $scope.reports.push({name: "User summary", link: globalService.gameConstants.petitionURL + "api/1/admin/report/user_summary"});
          // $scope.reports.push({name: "User summary certification", link: globalService.gameConstants.petitionURL + "api/1/admin/report/user_summary_certification"});
          // $scope.reports.push({name: "User interactions", link: globalService.gameConstants.petitionURL + "api/1/admin/report/user_interactions"});
        } else if (user.roles.indexOf("ROLE_REPORT_CREW") !== -1) {
          $scope.reports.push({name: "User summary", link: globalService.gameConstants.petitionURL + "api/1/report/user_summary"});
          // $scope.reports.push({name: "User summary certification", link: globalService.gameConstants.petitionURL + "api/1/report/user_summary_certification"});
          // $scope.reports.push({name: "User interactions", link: globalService.gameConstants.petitionURL + "api/1/report/user_interactions"});
        }

      });

      $scope.showBackIndicator = false;
      hideBackIndicatorOnHomeView();

      $scope.menuOpened = false;
      $document.on('click', function () {
        $scope.menuOpened = false;
      });

      $scope.$on("$destroy", function () {
        audioService.stop();
      });

    }

    $scope.toggleVolume = function () {

      var volume = audioService.getVolume();
      if (volume === 0 || volume === undefined) {
        apiCall.put("api/1/user/volume/enable").then(function (e) {
          $scope.iconVolume = iconVolumeOn;
          $rootScope.currentUser.volume = true;
          audioService.setVolume(gameSettings.globalAudio.default);
          if (!audioService.audioPlayer().isPlaying()) {
            audioService.play();
          }
        }).catch(function (e) {
          // console.log("Error enabling volume");
        })
      } else {
        apiCall.put("api/1/user/volume/disable").then(function () {
          $scope.iconVolume = iconVolumeOff;
          $rootScope.currentUser.volume = false;
          audioService.setVolume(0.0);
        })
          .catch(function (e) {
            // console.log("Error disabling volume");
          })
      }
    };

    $scope.showHelp = function () {
      $location.path('/onboarding')
    };

    $scope.hideHelp = function () {
      $scope.helpPopupAPI.close();
    };

    $scope.logout = function() {
      globalService.logout();
    };

    $scope.home = function () {
      $location.path('/home')
    };

    $scope.userProfileClick = function (event) {
      $scope.menuOpened = !$scope.menuOpened;
      event.stopPropagation();
    }

    $scope.showRankingDialog = function () {
      $scope.rankingPopupAPI.open();
    }

    $scope.downloadReport = function (link) {
      var fakeAnchor = document.createElement('a');
      fakeAnchor.href = link;
      fakeAnchor.download = link.substr(link.lastIndexOf('/') + 1);
      fakeAnchor.click();
    }

    $scope.selectLanguage = function (event, lang) {
      // todo: Show modal dialog to confirm language change
      var selectedElement = event.currentTarget;
      console.log('Updating user language at server, new language: ', lang);
      i18nService.getLocale(false, lang).then(function(i18n) { // Reload i18n from server
        // Overwrite all locale with new lang
        $rootScope.locale = i18n;

        globalService.userService.getUser(true); // Reload user info
        //$rootScope.$broadcast('languageChanged');
        //$location.path('/home');
        $window.location.reload();
      });
    };

    function hideBackIndicatorOnHomeView() {
      if ($location.path().indexOf("home") === -1) {
        $scope.showBackIndicator = true;
      }
      $rootScope.$on("$routeChangeSuccess", function ($event, next, current) {
        if (next.$$route !== undefined && next.$$route.originalPath.indexOf("home") === -1) {
          $scope.showBackIndicator = true;
        } else {
          $scope.showBackIndicator = false;
        }
      });

    }

    init();
  }
])
